import { AttributeType, Product, ProductCartModel } from "./types";

export const validateModel = (
  product: Product,
  productSelected: ProductCartModel
) => {
  const errors: Record<string, string> = {};

  if (!productSelected.Attributes) {
    return errors;
  }

  product.AttributeOptions.forEach((option) => {
    //
    if (option.Type === AttributeType.Custom) {
      if (!option.IsRequired) {
        return;
      }
    }

    const selectedOption = productSelected.Attributes.find(
      (att) => att.AttributeId === option.Id
    );

    if (!selectedOption) {
      errors[option.Id] = `${option.Name} is required`;
    }
  });

  return errors;
};
export function createModel(item: Product): ProductCartModel {
  return {
    Name: item.Name,
    Price: item.Price,
    OriginalPrice: item.OriginalPrice,
    ProductCode: item.UpcOrCode,
    ProductId: item.ProductId,
    Quantity: 1,
    Attributes: [],
  };
}
